import { render, staticRenderFns } from "./XhUser.vue?vue&type=template&id=201a57d6&scoped=true"
import script from "./XhUser.vue?vue&type=script&lang=js"
export * from "./XhUser.vue?vue&type=script&lang=js"
import style0 from "./XhUser.vue?vue&type=style&index=0&id=201a57d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201a57d6",
  null
  
)

export default component.exports